import { Link } from "react-router-dom";

const BackToAllProjects = (props) => {
    const customStyle = props.customStyle || "bg-pink-500 hover:bg-pink-600 text-white font-semibold text-[2rem] py-4 px-6 rounded-lg";
    const customText = props.customText || "back to all projects"
    return (
        <Link to="/projects">
            <div className="flex justify-center">
                <button className={customStyle}>
                    {customText}
                </button>
            </div>
        </Link>
    )
}


export default BackToAllProjects;